<template>
  <div class="decode-decrypt-flow">
    <!-- 解密方式选择弹窗 -->
    <a-modal
      v-model="caTypeDialogVisible"
      :title="`选择${preDecrypt ? '模拟' : ''}解密方式`"
      :footer="false"
      :mask-closable="false"
    >
      <div class="ca-type-list flex col-center">
        <div
          class="ca-type flex-column col-center m-r-24"
          :class="{ 'is-active': caType === 1 }"
          @click="selectCAType(1)"
        >
          <div class="ca-type__title m-b-8">电子CA</div>
          <div class="ca-type__tip m-b-16">打开支付宝扫一扫</div>
          <img
            style="width: 200px; height: 200px"
            :src="require('@/assets/images/hall/qr-ca.png')"
            alt=""
          />
        </div>
        <div
          class="ca-type flex-column col-center"
          :class="{ 'is-active': caType === 2 }"
          @click="selectCAType(2)"
        >
          <div class="ca-type__title m-b-8">实物CA</div>
          <div class="ca-type__tip m-b-16">电脑插入CA</div>
          <img
            style="width: 84px; height: 186px"
            :src="require('@/assets/images/hall/ukey-ca.png')"
            alt=""
          />
        </div>
      </div>
    </a-modal>

    <!-- 移动解密弹窗 -->
    <el-dialog
      :title="`${preDecrypt ? '模拟' : ''}文件解密`"
      :visible.sync="decodeDialogVisible"
      class="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      append-to-body
      width="300px"
    >
      <div class="dialog-content">
        <qrcode-vue
          v-if="qrCode"
          id="qrcodeBox"
          :size="160"
          :value="qrCode"
          bg-color="#fff"
          fg-color="#000"
        >
          <div v-if="!qrCode" class="get-code-again" @click="getDecryptQrCode">
            <a>重新获取二维码</a>
          </div>
        </qrcode-vue>

        <p class="m-t-16">请使用支付宝扫描二维码</p>
      </div>
    </el-dialog>

    <!-- 检测实体CA过渡弹窗 -->
    <a-modal
      v-model="caTransitionVisible"
      title="请插入CA，系统自动检测"
      :footer="false"
      :mask-closable="false"
    >
      <div class="ca-check flex-column col-center">
        <img
          style="width: 183px; height: 180px"
          :src="require('@/assets/images/hall/ukey-check.gif')"
          alt=""
        />
      </div>
    </a-modal>

    <!-- 选择CA服务商 -->
    <a-modal
      v-model="caPluginDialogVisible"
      title="请选择CA服务商"
      :footer="false"
      :mask-closable="false"
      append-to-body
      width="400px"
    >
      <div class="ca-body flex-column col-center">
        <img
          style="width: 68px; height: 106px"
          :src="require('@/assets/images/hall/ukey-success.png')"
          alt=""
          class="m-b-24"
        />
        <div
          v-for="(item, index) in CAPluginList"
          :key="`ca${index}`"
          class="ca-list-item"
          :class="{ 'is-active': CAPluginIndex === index }"
          @click="() => (CAPluginIndex = index)"
        >
          <span>{{ item.certSubjectCn }}({{ item.ukeySN }})</span>
        </div>
        <div style="width: 100%; padding: 0 10px;">
          <el-button type="text" @click="reCheckCA">重新插入检测</el-button>
        </div>
        <div class="flex row-center m-t-24">
          <el-button type="primary" @click="confirmSelectCAPlugin">
            确定
          </el-button>
        </div>
      </div>
    </a-modal>

    <!-- 查询业务解密结果弹窗 -->
    <div v-if="decryptSpinning" class="spin-wrap">
      <a-spin
        :tip="`正在努力排队${preDecrypt ? '模拟' : ''}解密中，请稍后……`"
        size="large"
      />
    </div>
  </div>
</template>

<script>
// 组件
import qrcodeVue from 'qrcode.vue'
// 接口
import {
  decryptBidFileApi,
  getDecodeResultApi,
  getDecryptFileResultApi,
  getDecryptQrCodeApi,
  getDecryptQrCodeResultApi,
  getDigitalEnvelopeApi,
  supplierDecodeApi
} from '@/api/hall/bid-open-hall'
// 字典
import { CATypeDict } from '@/dictionary/ca'
import {
  fileDecryptionStatusDict,
  filePreDecryptionStatusDict
} from '@/dictionary/hall/open-bid-hall'
import {
  bidFileTypeDict,
  reviewModelDict
} from '@/dictionary/project/kpb-project'

/**
 * @description 解密流程
 */
export default {
  name: 'DecryptFlow',

  components: { qrcodeVue },

  props: {
    // 项目id
    projectId: {
      type: [String, Number],
      required: true
    },

    // 投标单位id
    bidderId: {
      type: [String, Number],
      required: true
    },

    // 是否是供应商
    isSupplier: {
      type: Boolean,
      default: false
    },

    // 加密文件id
    encryptFileId: {
      type: [Number, String],
      required: true
    },

    // 是否进行预解密
    preDecrypt: {
      type: Boolean,
      default: false
    },

    // 评审模式
    reviewModel: {
      type: [String, Number],
      default: reviewModelDict.DEFAULT.value
    }
  },

  data() {
    return {
      decodeDialogVisible: false,
      // 选择解密方式弹窗
      caTypeDialogVisible: false,
      caType: 0,
      // 系统检测实体CA过渡弹窗
      caTransitionVisible: false,
      CAPluginList: [],
      caPluginDialogVisible: false,
      CAPluginIndex: '',
      decryptSpinning: false,

      timer: null,

      // 移动解密任务
      mobileDecodeTask: {},
      // 解密任务id
      mobileTaskId: 0,

      // 文件类型
      bidFileType: bidFileTypeDict.BUSINESS.value
    }
  },

  computed: {
    qrCode() {
      return this.mobileDecodeTask.url || ''
    }
  },

  watch: {
    decodeDialogVisible(val) {
      if (val) {
        this.getDecryptQrCode()
      } else {
        clearInterval(this.timer)
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    /**
     * 选择解密方式
     */
    selectCAType(value) {
      this.caType = value
      if (this.caType === 1) {
        // 扫码解密
        this.decodeDialogVisible = true
      }

      if (this.caType === 2) {
        this.caTransitionVisible = true
        // 实体解密
        this.TG_GetCAProviderList()
      }

      this.caType = 0

      this.caTypeDialogVisible = false
    },

    /**
     * 移动解密-获取移动CA解密二维码
     */
    getDecryptQrCode() {
      const params = {
        reviewModel: this.reviewModel,
        bidFileType: this.bidFileType
      }
      getDecryptQrCodeApi(this.encryptFileId, params)
        .then(res => {
          this.mobileDecodeTask = res.data
          this.mobileTaskId = res.data.taskId
          this.startCheckQrCodeResult()
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 移动解密-开始获取移动CA解密二维码扫码结果轮询
     */
    startCheckQrCodeResult() {
      clearInterval(this.timer)
      this.getDecryptQrCodeResult()
      this.timer = setInterval(() => {
        this.getDecryptQrCodeResult()
      }, 2000)
    },

    /**
     * 移动解密-获取移动CA解密二维码扫码结果
     */
    getDecryptQrCodeResult() {
      return getDecryptQrCodeResultApi(this.mobileTaskId)
        .then(res => {
          if (!res.data) {
            clearInterval(this.timer)
            this.$message.error('获取移动CA解密二维码扫码结果失败')
            return
          }

          if (res.data?.status === 1) {
            clearInterval(this.timer)
            this.decryptBidFile(res.data.symmetricKey || '')
          }
        })
        .catch(err => {
          clearInterval(this.timer)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 实体CA解密-获取CA列表
     */
    TG_GetCAProviderList() {
      this.$store
        .dispatch('kingGrid/getCAList', CATypeDict.UKEY.value)
        .then(certList => {
          this.CAPluginList = certList || []
          if (this.CAPluginList.length > 0) {
            this.caTransitionVisible = false
            this.caPluginDialogVisible = true
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 重新检测CA
     */
    reCheckCA() {
      this.caTransitionVisible = true
      this.caPluginDialogVisible = false
      this.TG_GetCAProviderList()
    },

    /**
     * 确认选择的CA服务
     */
    confirmSelectCAPlugin() {
      this.caPluginDialogVisible = false
      // const param = this.CAPluginList[this.CAPluginIndex]
      this.getDigitalEnvelop()
    },

    /**
     * 实体CA解密-获取数字信封
     */
    getDigitalEnvelop() {
      const params = {
        reviewModel: this.reviewModel,
        bidFileType: this.bidFileType
      }
      getDigitalEnvelopeApi(this.encryptFileId, params)
        .then(res => {
          const { data = {} } = res
          this.TG_DecryptData(data)
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 实体CA解密-调用CA中间件解密数字信封
     */
    TG_DecryptData(digitalEnvelope) {
      this.$store
        .dispatch('kingGrid/decryptData', digitalEnvelope)
        .then(res => {
          this.decryptBidFile(res)
        })
        .catch(err => {
          console.error('TG_DecryptData err: ', err)
          if (err?.message) this.$message.error(err.message)
          if (err?.errorMsg) this.$message.error(err.errorMsg)
        })
    },

    /**
     * 解密标书
     */
    decryptBidFile(symmetricKey) {
      decryptBidFileApi(this.encryptFileId, {
        symmetricKey,
        kpbProjectId: this.projectId,
        preDecrypt: this.preDecrypt,
        bidFileType: this.bidFileType
      })
        .then(res => {
          console.log('decryptBidFile res: ', res)
          this.pollingDecryptResult()
        })
        .catch(err => {
          console.error('decryptBidFile err: ', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 轮询业务端解密结果
     */
    pollingDecryptResult() {
      clearInterval(this.timer)
      this.checkDecryptResult({
        showToast: true,
        bidFileType: this.bidFileType
      })
      this.timer = setInterval(() => {
        this.checkDecryptResult({
          showToast: true,
          bidFileType: this.bidFileType
        })
      }, 2000)
    },

    /**
     * 查询业务端解密结果
     */
    checkDecryptResult(
      config = { showToast: true, bidFileType: bidFileTypeDict.BUSINESS.value }
    ) {
      this.bidFileType = config.bidFileType
      if (config.showToast) this.decryptSpinning = true

      if (!this.projectId || !this.bidderId) {
        console.error('缺少项目id或投标单位id', this.projectId, this.bidderId)
        return Promise.reject()
      }

      if (!this.encryptFileId) {
        return Promise.reject()
      }

      // 默认查询采购人端的解密结果接口
      let checkResultApi = getDecodeResultApi
      // 如果是供应商，则调用供应商端查询解密结果的接口
      if (this.isSupplier) {
        checkResultApi = supplierDecodeApi
      }
      // 如果是预解密，则调用供应商查询预解密结果的接口
      if (this.preDecrypt) {
        checkResultApi = getDecryptFileResultApi
      }

      return new Promise((resolve, reject) => {
        checkResultApi(
          {
            projectId: this.projectId,
            bidderId: this.bidderId,
            encryptFileId: this.encryptFileId
          },
          {
            bidFileType: config.bidFileType
          }
        )
          .then(res => {
            const decryptStatus =
              res?.data?.status || fileDecryptionStatusDict.PENDING.value
            // 预解密状态
            const preStatus =
              res?.data?.preStatus || filePreDecryptionStatusDict.PENDING.value
            if (
              (decryptStatus === fileDecryptionStatusDict.FAIL.value &&
                config.showToast) ||
              (preStatus === filePreDecryptionStatusDict.FAIL.value &&
                config.showToast)
            ) {
              this.$message.error(
                `${
                  this.preDecrypt ? '模拟' : ''
                }文件解密失败，请检查UKey或加密文件`
              )
              this.decryptSpinning = false
              this.decodeDialogVisible = false
              clearInterval(this.timer)
            }

            if (
              decryptStatus === fileDecryptionStatusDict.SUCCESS.value ||
              preStatus === filePreDecryptionStatusDict.SUCCESS.value
            ) {
              if (config.showToast) {
                this.$message.success(
                  `文件${this.preDecrypt ? '模拟' : ''}解密成功`
                )
              }
              this.decryptSpinning = false
              this.decodeDialogVisible = false
              clearInterval(this.timer)
            }

            this.$emit(
              'getResult',
              decryptStatus,
              preStatus,
              config.bidFileType
            )
            resolve(res)
          })
          .catch(err => {
            console.error('查询业务端解密结果失败', err)
            this.decryptSpinning = false
            clearInterval(this.timer)
            if (err?.message) this.$message.error(err.message)
            reject(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ca-type-list {
  .ca-type {
    width: 240px;
    height: 320px;
    box-sizing: border-box;
    padding: 24px 20px 32px 20px;
    border: 1px solid $info-third-color;

    &.is-active {
      border: 1px solid $primary-color;
    }

    .ca-type__title {
      font-size: 14px;
      color: $text-color;
      @include text-bold;
    }

    .ca-type__tip {
      font-size: 14px;
      color: $second-text-color;
    }
  }
}

.ca-list-item {
  padding: 10px 36px;
  background: $info-fifth-color;
  cursor: pointer;

  span {
    font-size: 14px;
    color: $text-color;
    @include text-bold;
  }

  &.is-active {
    background: $primary-color;
    span {
      color: $white-color;
    }
  }
}

.spin-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
}
</style>
